import { Col, Row } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { BsEnvelopePaperHeart, BsPersonCircle } from "react-icons/bs";
import { FaCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DashBoardMiddleware } from "../../../Store/Middlewares/DashBoardMiddleware";
import placeholderImg from "../../../assets/dummy.png";
import videoCallIcon from "../../../assets/videoCall.png";
import { SubmitButton, TextComponent } from "../../../components";
import {
  CalendarIcon,
  ClockIcon,
  LocIcon,
} from "../../../components/icons/Icons";
import Modal from "../../../components/modal/Modal";
import styles from "./GuestHome.module.css";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";

const LiveModal = ({ setLiveModalOpen,onJoinStream }) => {
  const navigate = useNavigate();

  return (
    <Row gutter={[8, 24]} className={styles.modalContentRow}>
      {/* <MdDelete className={styles.deleteIcon} /> */}
      <Col xs={24} md={10}>
        <svg
          className={styles.svgIcon}
          viewBox="0 0 318 219"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M262.459 184.391C262.459 190.06 262.568 193.434 262.432 196.808C261.926 209.335 253.238 218.556 240.78 218.624C197.053 218.843 153.339 218.829 109.612 218.651C96.7988 218.597 87.701 209.376 87.6053 196.508C87.3868 167.602 87.3868 138.697 87.6053 109.791C87.701 96.9368 96.8125 87.7296 109.626 87.675C153.121 87.4974 196.616 87.5111 240.111 87.675C253.293 87.7296 262.09 96.9368 262.459 110.215C262.541 113.357 262.473 116.512 262.473 121.649C267.309 119.927 271.434 119.149 274.781 117.113C282.95 112.155 290.477 106.117 298.823 101.554C302.293 99.6552 308.14 98.7263 311.2 100.434C314.287 102.141 316.828 107.633 316.882 111.513C317.361 139.271 317.361 167.042 316.882 194.8C316.814 198.68 314.26 204.171 311.172 205.879C308.112 207.573 302.266 206.63 298.796 204.745C290.449 200.183 282.895 194.158 274.754 189.172C271.53 187.178 267.555 186.317 262.459 184.391ZM240.329 109.955C196.438 109.955 153.107 109.955 109.968 109.955C109.968 139.189 109.968 167.93 109.968 196.522C153.695 196.522 196.862 196.522 240.329 196.522C240.329 167.575 240.329 138.997 240.329 109.955ZM262.773 164.761C276.352 160.54 284.698 170.28 294.848 175.867C294.848 160.349 294.848 145.773 294.848 130.104C284.657 137.003 275.874 145.377 262.773 141.798C262.773 149.734 262.773 156.469 262.773 164.761Z"
            className={styles.svgIconPath}
          />
          <path
            d="M0.125085 94.0819C1.60041 43.4426 46.1199 0.056938 96.363 0.166222C101.882 0.179882 107.018 1.58691 108.22 7.1194C108.999 10.7394 107.865 15.7528 105.652 18.7035C103.931 20.9848 99.2727 21.8044 95.8576 21.9547C61.0644 23.4846 31.7627 47.4861 23.9079 81.3503C22.8834 85.749 22.337 90.3253 22.0638 94.8332C21.4627 104.696 17.7198 109.655 10.6163 109.395C3.48556 109.163 -0.161785 103.835 0.125085 94.0819Z"
            className={styles.svgIconPath}
          />
          <path
            d="M43.8548 96.3368C44.3739 68.6061 68.8398 44.2768 96.5569 43.9353C104.002 43.8396 108.974 47.8422 109.357 54.2079C109.726 60.5464 105.136 65.1363 97.7863 65.751C79.0851 67.322 67.1322 79.1246 65.6842 97.4433C65.0832 105.066 60.9031 109.546 54.5236 109.424C47.8847 109.273 43.7182 104.178 43.8548 96.3368Z"
            className={styles.svgIconPath}
          />
          <path
            d="M202.476 153.177C191.316 153.164 186.193 149.858 186.002 142.536C185.797 134.941 191.152 131.321 202.572 131.307C203.706 131.307 204.84 131.293 205.96 131.307C213.883 131.484 218.732 135.678 218.705 142.29C218.678 148.888 213.801 153.013 205.864 153.177C204.73 153.205 203.61 153.177 202.476 153.177Z"
            className={styles.svgIconPath}
          />
        </svg>
      </Col>

      <Col xs={20} md={14}>
        <TextComponent textClass={styles.modalText1}>
          Do You Want To Join
        </TextComponent>
        <TextComponent textClass={styles.modalText2}>
          Live Streaming!!
        </TextComponent>
        <div className={styles.modalBtnContainer}>
          <SubmitButton
            title="Yes"
            btnClass={styles.modalBtn}
            onClick={() => onJoinStream()}
          />
          <SubmitButton
            title="No"
            outline={true}
            btnClass={styles.modalBtn}
            onClick={() => setLiveModalOpen(false)}
          />
        </div>
      </Col>
    </Row>
  );
};

const GuestHome = () => {
  const [liveModalOpen, setLiveModalOpen] = useState(false);
  const navigate = useNavigate();

  const user = useSelector((state) => state.AuthReducer.user);
  const [liveStart, setLiveStart] = useState(false);
  const dispatch = useDispatch();
  const GuestsData = useSelector(
    (state) => state.DashboardReducer.guestDashboardData
  );
  const Events = GuestsData?.events;
  const UpcomingEvents = GuestsData?.upcoming;
  const currentEvent = GuestsData.current;
  // const {width} = Dimensions.get('screen');
  const [loading, setloading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    getGuestDashBoardData();
    // getNotification()
  }, []);

  const getGuestDashBoardData = () => {
    dispatch(DashBoardMiddleware.getGuestDashBoard())
      .then(() => setloading(false))
      .catch(() => setloading(false));
  };


  const onJoinStream = () => {
    setLiveStart(false);
    let eventData = {
      event_id: currentEvent?.id,
    };
    dispatch(EventMiddleware.joinStrean(eventData))
      .then(data => {
        navigate("/events/eventDetail/liveStream", {
          state: {
            data,
          },
        })
      })
      .catch(err => console.log(err));
  };

  return (
    <>
      <TextComponent textClass={styles.mainHeading}>
        Welcome, {user?.first_name + "!"}
      </TextComponent>
      <Row className={styles.contentRow} gutter={[12, 0]}>
        <Col xs={24} lg={14} xl={17}>
          <TextComponent textClass={styles.leftColHeading}>
            Events
          </TextComponent>
          <Row className={styles.eventCard} gutter={[12, 32]}>
            {Events?.map((item) => (
              <Col xs={24} sm={12} xl={6} key={item?.id}>
                <div className={styles.cardBg}>
                  <Row style={{ position: "relative" }}>
                    <img
                      src={item?.image ? item?.image : placeholderImg}
                      alt="Event Image"
                      style={{ width: "100%", padding: "0 12px 7px" }}
                    />
                    <div className={styles.eventDate}>
                      <TextComponent>
                        {moment(item?.date).format("MMM DD")}
                      </TextComponent>
                    </div>
                    <div className={styles.envIcon}>
                      <BsEnvelopePaperHeart />
                    </div>
                  </Row>
                  <TextComponent textClass={styles.cardTitle}>
                    {item?.name.split(" ")[0]}
                  </TextComponent>
                  <TextComponent textClass={styles.cardDetail}>
                    {`${moment(item?.start_time).format("ddd, HH:MM")} · ${item?.address
                      }`}
                  </TextComponent>
                </div>
              </Col>
            ))}
          </Row>
          <Row>
            <Col xs={24} style={{ position: "relative" }}>
              <img
                src={currentEvent?.image ? currentEvent?.image : placeholderImg}
                alt="Event Image"
                className={styles.detailBgImg}
              />
              {currentEvent?.name && (
                <div className={styles.imageTextContainer}>
                  <div className={styles.pinkBg}></div>
                  <div className={styles.imageText}>
                    <TextComponent textClass={styles.imageText1}>
                      {currentEvent?.category?.name}
                    </TextComponent>
                    <Row className={styles.title}>
                      <TextComponent textClass={styles.imageText2}>
                        {currentEvent?.name}
                      </TextComponent>
                      <TextComponent textClass={styles.imageText2Active}>
                        {currentEvent?.status}
                      </TextComponent>
                    </Row>
                    <Row className={styles.bottomRow}>
                      <Col xs={24} xl={8}>
                        <Row
                          className={styles.locationRow}
                          gutter={[8, 0]}
                          justify={{ xs: "center", xl: "flex-start" }}
                        >
                          <Col>
                            <LocIcon
                              size={40}
                              className={styles.locationIcon}
                            />
                          </Col>
                          <Col>
                            <TextComponent textClass={styles.address1}>
                              {currentEvent?.address
                                ? currentEvent?.address
                                : "--"}
                            </TextComponent>
                            <br />
                            {/* <TextComponent textClass={styles.address2}>
                            California
                          </TextComponent> */}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} xl={16}>
                        <Row className={styles.detailRow}>
                          <Col className={styles.iconCol}>
                            <Row className={styles.iconRow}>
                              {/* <AiOutlineCalendar className={styles.bottomIcon} /> */}
                              <CalendarIcon size={20} color="#000" />
                              <TextComponent textClass={styles.iconText}>
                                {moment(currentEvent?.date).format(
                                  "MMM DD, YYYY"
                                )}
                              </TextComponent>
                            </Row>
                          </Col>
                          <Col className={styles.iconCol}>
                            <Row className={styles.iconRow}>
                              <FaCircle className={styles.bottomIcon} />
                              <div>
                                <TextComponent textClass={styles.iconText}>
                                  {`${currentEvent?.no_of_guest || 0}+ Guest`}
                                </TextComponent>
                                <TextComponent textClass={styles.availableText}>
                                  Available
                                </TextComponent>
                              </div>
                            </Row>
                          </Col>
                          <Col className={styles.iconCol}>
                            <Row className={styles.iconRow}>
                              {/* <AiOutlineClockCircle
                              className={styles.bottomIcon}
                            /> */}
                              <ClockIcon size={20} color={"#000"} />
                              <TextComponent textClass={styles.iconText}>
                                {moment(currentEvent?.start_time).format(
                                  "hh:mm"
                                )}
                              </TextComponent>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <div
                      className={styles.videoIcon}
                      onClick={() => setLiveModalOpen(true)}
                    >
                      <img
                        src={videoCallIcon}
                        alt="Video Call Icon"
                        className={styles.videoIconImg}
                      />
                      {/* <FiVideo /> */}
                    </div>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Col>
        <Col xs={24} lg={10} xl={7} className={styles.rightCol}>
          {UpcomingEvents?.length > 0 && (
            <Row className={styles.rightColHeader}>
              <Col>
                <TextComponent textClass={styles.rightColHeading}>
                  Upcoming Events
                </TextComponent>
              </Col>
              <Col>
                <TextComponent
                  textClass={styles.viewAllText}
                  onClick={() => navigate("/guestEvents")}
                >
                  View All
                </TextComponent>
              </Col>
            </Row>
          )}
          {UpcomingEvents?.map((item) => (
            <Row>
              <Col xs={24} className={styles.rightContentRow}>
                {/* <div style={{ padding: "12px", height: "100%" }}> */}
                <Row style={{ position: "relative" }}>
                  <img
                    src={item?.image ? item?.image : placeholderImg}
                    alt="Event"
                    style={{ width: "100%" }}
                  />
                  <div className={styles.date}>
                    <TextComponent>
                      {moment(item?.date).format("MMM DD")}
                    </TextComponent>
                  </div>
                </Row>
                <Row className={styles.eventTitleRow}>
                  <TextComponent textClass={styles.eventTitle}>
                    {item?.name}
                  </TextComponent>
                </Row>
                <Row className={styles.eventDetailRow}>
                  <TextComponent textClass={styles.eventDetail}>
                    {`${moment(item?.start_time).format("ddd hh:mm")} · ${item?.address
                      }`}
                  </TextComponent>
                </Row>
                <Row className={styles.statsRow}>
                  {/* <Col>
                    <Row className={styles.singleStat}>
                      <BiSolidMusic />
                      <TextComponent textClass={styles.statsText}>
                        0
                      </TextComponent>
                    </Row>
                  </Col>
                  <Col>
                    <Row className={styles.singleStat}>
                      <FaClipboardList />
                      <TextComponent textClass={styles.statsText}>
                        23%
                      </TextComponent>
                    </Row>
                  </Col> */}
                  <Col>
                    <Row className={styles.singleStat}>
                      <BsPersonCircle color="var(--primary-color)" />
                      <TextComponent textClass={styles.statsText}>
                        {`${item?.no_of_guest} Guest`}
                      </TextComponent>
                    </Row>
                  </Col>
                </Row>
                {/* </div> */}
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
      <Modal
        isModalOpen={liveModalOpen}
        setIsModalOpen={setLiveModalOpen}
        closable={true}
        pinkBg={true}
        wideModal={true}
        className={styles.modal}
      >
        <LiveModal setLiveModalOpen={setLiveModalOpen} onJoinStream={onJoinStream}/>
      </Modal>
    </>
  );
};

export default GuestHome;
